"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var validateAccessToken_middleware_1 = require("./validateAccessToken.middleware");

exports.validateAccessToken = validateAccessToken_middleware_1.validateAccessToken;